import script from "./AppCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./AppCheckbox.vue?vue&type=style&index=0&id=64f75a3a&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f75a3a"]])

export default __exports__